import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-popup',
    standalone: true,
    imports: [CommonModule, TranslateModule, NgbModalModule],
    template: `
        <div class="modal-header border-0">
            <button type="button" class="btn-close" aria-label="close" (click)="onCancel()">
                <em class="flaticon-close"></em>
            </button>
        </div>
        <div class="modal-body text-center pt-0">
            <img class="icon-width-nav" [src]="CDN_URL + 'coinInfo/icon/' + 'logout-img.png'" alt="" />
            <h5>{{ data.title | translate }}</h5>
            <p>{{ data.message | translate }}</p>
            <div>
                <button type="submit" aria-label="yes" class="btn-twice-outline" (click)="onLogout()">
                    {{ 'GENERAL.YES' | translate }}
                </button>
                <button type="submit" aria-label="cancel" class="btn-default btn-secondary ms-2" (click)="onCancel()">
                    {{ 'GENERAL.NO' | translate }}
                </button>
            </div>
        </div>
    `,
    styleUrls: ['./confirm-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmPopupComponent {
    @Input() data!: { title: string; message: string };
    CDN_URL = environment.CDN_URL;

    private activeModal = inject(NgbActiveModal);

    onCancel() {
        this.activeModal.close(false);
    }

    onLogout() {
        this.activeModal.close(true);
    }
}
